"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _rendererCore = require("@quillforms/renderer-core");
var _utils = require("@quillforms/utils");
var styles = _interopRequireWildcard(require("./styles"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * QuillForms Dependencies
 */

/**
 * InternaL Dependencies
 */

const CloseIcon = props => {
  const theme = (0, _rendererCore.useTheme)();
  const cx = (0, _utils.useCx)();
  return (0, _react.createElement)("div", {
    ...props,
    className: cx('block-dropdown-renderer-close-icon', styles.iconStyles)
  }, (0, _react.createElement)("svg", {
    height: "32",
    width: "32",
    viewBox: "0 0 512 512",
    className: cx((0, _utils.css)`
					fill: ${theme.answersColor};
				`)
  }, (0, _react.createElement)("g", null, (0, _react.createElement)("g", null, (0, _react.createElement)("g", null, (0, _react.createElement)("polygon", {
    points: "405,136.798 375.202,107 256,226.202 136.798,107 107,136.798 226.202,256 107,375.202 136.798,405 256,285.798\r 375.202,405 405,375.202 285.798,256 \t\t"
  }, (0, _react.createElement)("polygon", {
    points: "405,136.798 375.202,107 256,226.202 136.798,107 107,136.798 226.202,256 107,375.202 136.798,405 256,285.798\r 375.202,405 405,375.202 285.798,256 \t\t"
  })))))));
};
var _default = exports.default = CloseIcon;
//# sourceMappingURL=close-icon.js.map